import { takeLatest, call, put, takeEvery, select } from 'redux-saga/effects';
import * as api from '../../../server';
import { message } from 'antd';
import * as Type from "../../actions/actionTypes";

message.config({
  duration: 2,
  maxCount: 1,
});

//列表获取
export function* getList(action) {
  try {
    const { activeTab } = yield select(state => state.menuInfo);
    const { searchParams = {}, currentPage = '1', pageSize = '10' } = yield select(state => state.casepool[activeTab.key] || {});
    // 在线调解页面 会按id进一步筛选
    const lastParams = action?.mediationIds ? { ...searchParams,  mediationIds: action?.mediationIds } : searchParams
    const res = yield call(api.getList, lastParams, activeTab.pathUrl, currentPage, pageSize);
    yield put({
      type: Type.SET_LIST,
      list: res.caseList,
      // pageSize: action.pageSize,
      total: res.totalNum,
      // currentPage: action.page,
      roleKey: activeTab.key,
    })
    if(action?.cb){
      yield call(action.cb);
    }
  } catch (error) {
    console.error(error)
  }
}

export function* getListRequest() {
  yield takeLatest(Type.GET_LIST, getList)
}

// tab切换时更新初始form数据，判断上一个activeKey，是否还存在于tabsList中，存在则保存，不存在说明删除了，不作变化
export function* setInitForm(action) {
  try {
    const { oldKey, initialFormValues } = action;
    const { tabsList } = yield select(state => state.menuInfo);
    const isFindKey = tabsList.find(tab => tab.key === oldKey);
    if (isFindKey) { // 存在说明没关闭
      yield put({
        type: Type.CURRENTFIELD,
        roleKey: oldKey,
        initialFormValues,
      });
    }
  } catch (error) {
    console.log(error)
  }
}

export function* setInitFormListener() {
  yield takeLatest(Type.INITFORM, setInitForm);
}

// 多人调解获取场次
export function* getMediationSession(action) {
  try {
    const res = yield call(api.getMediationSession, action.path, action.params);
    if(res.status === 2000){
      const { cb = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb,res?.data);
    } else {
    yield put({ type: 'HIDE_LOADING' })
    message.error(res?.des)
    }
  } catch (error) {
    console.log(error)
  }
}

export function* getMediationSessionRequest() {
  yield takeLatest(Type.GET_MEDIATION_SESSION, getMediationSession);
}

// 批量开启在线调解
export function* postMediationBatch(action) {
  try {
    const res = yield call(api.postMediationBatch, action.path, action.params);
    if(res.status === 2000){
      const { cb = window.noop } = action
      yield put({ type: 'HIDE_LOADING' })
      yield call(cb,res?.data);
    } else {
    yield put({ type: 'HIDE_LOADING' })
    message.error(res?.des)
    }
  } catch (error) {
    console.log(error)
  }
}

export function* postMediationBatchRequest() {
  yield takeLatest(Type.POST_MEDIATION_BATCH, postMediationBatch);
}

//立案
// export function* regist(action) {
//     try {
//         const res = yield call(api.registeCase, action.param, action.path);
//         if (res.status === 0) {
//             const { cb = window.noop } = action
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cb);
//         } else {
//             const { cbF = window.noop } = action
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cbF, res.msg);
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* registRequest() {
//     yield takeLatest(Type.GET_REGIST, regist)
// }

//批量导入
// export function* importInfo(action) {
//     try {
//         const res = yield call(api.importInfo, action.param, action.path);
//         if (res.status === 0) {
//             const { cbSucc = window.noop, } = action
//             yield put({ type: 'HIDE_LOADING' })
//
//             yield call(cbSucc);
//         } else {
//             const { cbFail = window.noop } = action
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cbFail, res.msg);
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* importInfoRequest() {
//     yield takeLatest(Type.GET_IMPORTINFO, importInfo)
// }
//
//
// export function* batchDownload(action) {
//     try {
//         const res = yield call(api.batchDownload, JSON.stringify(action.param), action.path);
//         yield put({
//             type: Type.SET_BATCHDOWNLOAD,
//             src: res.url,
//             roleKey: action.roleKey
//         })
//         const { cb = window.window.noop } = action;
//         yield call(cb)
//     } catch (error) {
//         console.error(error)
//     }
// }
//
// export function* batchDownloadRequest() {
//     yield takeLatest(Type.GET_BATCHDOWNLOAD, batchDownload)
// }
// //登记备注
// export function* otherRemarkUp(action) {
//     try {
//         const res = yield call(api.otherRemarkUp, action.params, action.systemNum, action.path);
//         if (res) {
//             const { cb = window.noop } = action
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cb);
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* otherRemarkUpRequest() {
//     yield takeLatest(Type.GET_OTHERREMARKUP, otherRemarkUp)
// }
//
// //电子卷宗打印
// export function* pdfConversion(action) {
//     try {
//         const res = yield call(api.pdfConversion, action.params, action.systemNum, action.path);
//         if (res) {
//             const { cb = window.noop } = action
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cb, res.resId);
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* pdfConversionRequest() {
//     yield takeLatest(Type.GET_PDFCONVERSION, pdfConversion)
// }
// //文书打印
// export function* judicialDocPrint(action) {
//     try {
//         const res = yield call(api.judicialDocPrint, action.params, action.path);
//         const { cb = window.noop, cbF = window.noop  } = action
//         if (res.status === 0) {
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cb(res.url));
//         } else if (res.status === 1) {
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cbF, res.msg);
//             yield call(cb, res.url);
//         } else {
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cbF, res.msg);
//
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* judicialDocPrintRequest() {
//     yield takeLatest(Type.GET_JUDICIALDOCPRINT, judicialDocPrint)
// }
//
// //批量撤销调解审核
// export function* mediCancelReview(action) {
//     try {
//         const res = yield call(api.mediCancelReview, action.param, action.path);
//         if (res.status === 0) {
//             const { cb = window.noop, } = action
//             yield put({ type: 'HIDE_LOADING' })
//
//             yield call(cb);
//         } else {
//             const { cbF = window.noop } = action
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cbF, res.msg);
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* mediCancelReviewRequest() {
//     yield takeLatest(Type.GET_MEDICANCELREVIEW, mediCancelReview)
// }
//录入民诉前调案号
// export function* befLitiMediNumRegtReq(action) {
//     try {
//         const res = yield call(api.befLitiMediNumRegtReq, action.params, action.systemNum, action.path);
//         if (res) {
//             const { cb = window.noop } = action;
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cb);
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* befLitiMediNumRegtReqRequest() {
//     yield takeLatest(Type.GET_BEFLITIMEDINUMREGTREQ, befLitiMediNumRegtReq)
// }
//提交司法确认
// export function* judiConfirmCommit(action) {
//     try {
//         const res = yield call(api.judiConfirmCommit, action.param, action.path);
//         if (res.status === 0) {
//             const { cb = window.noop, } = action
//             yield put({ type: 'HIDE_LOADING' })
//
//             yield call(cb);
//         } else {
//             const { cbF = window.noop } = action
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cbF, res.msg);
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* judiConfirmCommitRequest() {
//     yield takeLatest(Type.GET_JUDICONFIRMCOMMIT, judiConfirmCommit)
// }
// //生成司法确认申请书
// export function* judiConfirmeDocGen(action) {
//     try {
//         const res = yield call(api.judiConfirmeDocGen, action.param, action.path);
//         if (res.status === 0) {
//             const { cb = window.noop, } = action
//             yield put({ type: 'HIDE_LOADING' })
//
//             yield call(cb, res.docList);
//         } else {
//             const { cbF = window.noop } = action
//             yield put({ type: 'HIDE_LOADING' })
//             yield call(cbF, res.msg);
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* judiConfirmeDocGenRequest() {
//     yield takeLatest(Type.GET_JUDICONFIRMEDOCGEN, judiConfirmeDocGen)
// }
//
//
// export function* getSmsData(action) {
//     try {
//         const res = yield call(api.getSmsData, action.param);
//         if (res) {
//             yield put({
//                 type: Type.SET_SMSDATA,
//                 court: res.court,
//                 caseNum: res.caseNum,
//                 docList: res.docList
//             });
//         }
//
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* getSmsDataRequest() {
//     yield takeLatest(Type.GET_SMSDATA, getSmsData)
// }
// 获取状态列表
export function* getStatusDict(action) {
  try {
    const { roleKey, path, dictType } = action;
    const statusList = yield call(api.getStatusDict, path, dictType);
    if (statusList) {
      yield put({
        type: Type.SET_STATUS_DICT,
        statusList,
        roleKey,
        dictType,
      });
    } else {
      yield put({ type: 'HIDE_LOADING' });
      message.error('无状态列表')
    }

  } catch (error) {
    console.error(error)
  }
}

export function* getStatusDictRequest() {
  yield takeEvery(Type.GET_STATUS_DICT, getStatusDict)
}

// 批量操作
export function* handleBatch(action) {
  try {
    const { cb = window.noop, error = window.noop, param, name, path, close = window.noop } = action;
    const res = yield call(api.handleBatch, param, path, name);
    if (res.status === 0 || res.status === 2000) {
      if (name === 'jcDocService') {
        yield put({ type: 'HIDE_LOADING' })
        yield call(close);
        if (!!res.url) {
          const wd = window.open(res.url, 'newwindow', 'height=0, width=0, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no');
          wd.print();
        }
      } else {
        yield put({ type: 'HIDE_LOADING' })
        yield call(cb, res.msg??res.des);
      }
      // message.success(res.msg)
    } else {
      yield put({ type: 'HIDE_LOADING' })
      yield call(action.error, res.msg??res.des);
    }
  } catch (error) {
    console.error(error)
  }
}

export function* handleBatchRequest() {
  yield takeLatest(Type.GET_HANDLE_BATCH, handleBatch)
}

// // 下载EMS
// export function* downloadEMS(action) {
//     try {
//         const res = yield call(api.downloadEMS, action.param, action.path);
//         if (res.status === 0) {
//             const a = window.document.createElement('a');
//             const filename = '';
//             a.href = res.url;
//             a.download = decodeURI(filename);
//             a.click();
//             window.URL.revokeObjectURL(res.url);
//         } else {
//             message.error(res.des)
//         }
//     } catch (error) {
//         console.error(error)
//     }
// }
// export function* downloadEMSRequest() {
//     yield takeLatest(Type.DOWNLOAD_EMS, downloadEMS)
// }
